import { Injectable } from '@angular/core';
import { AttributionService } from '../attribution/attribution.service';
import { AutresInformationsService } from '../autresInformations/autres-informations.service';
import { AvisInitialService } from '../avisInitial/avis-initial.service';
import { DescriptionReduiteService } from '../descriptionReduite/description-reduite.service';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';

@Injectable({
  providedIn: 'root'
})
export class FormDiversAttributionService {

  constructor(public attributionService: AttributionService, public autreInformationService: AutresInformationsService,
              public avisInitialService: AvisInitialService,
              public descriptionReduiteService: DescriptionReduiteService, public formExtractorService: FormExtractorService) {
  }
}
